import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueI18n from 'vue-i18n'

Vue.config.productionTip = false

const moment = require('moment')
require('moment/locale/sv')

Vue.use(require('vue-moment'), {
  moment
})

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'sv' // set locale
})

// Fetch token from localStorage
const token = localStorage.getItem('token')

// Will prepend all the requests with token from localStorage
if (token) {
  axios.defaults.headers.common.Authorization = token
}

// Global filters, use in templates as such: {{value | filter(arg1, arg2)}}
Vue.filter('toPercent', function (value) {
  if (value === 0) return 0
  if (!value) return ''
  return Math.round(value * 100)
})

Vue.filter('numberSpacing', function (value) {
  if (!value) return ''
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
})

Vue.filter('fromNow', function (date) {
  return moment(date).fromNow()
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
